import React, { useEffect, useState } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { hospitalsActions } from '../../../actions/hospitalsActions'
import { routes } from '../../../constantes/routes'
import HospitalsList from './HospitalsList'
import Search from '../../common/Search'
import PlusBtn from '../../buttons/PlusBtn'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import Header from '../../header/Header'
import _ from 'lodash'
import { hospitalsTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { exportActions } from '../../../actions/exportActions'
import { entitiesExport } from '../../../constantes/exportEndpoints'
import { downloadCSV } from '../../../utils/downloadCSV'

const HospitalsContainer = () => {
  const history = useHistory()

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  const userProfile = useSelector((state) => state.userProfile)
  const hospitalsList = useSelector((state) => state.hospitals)
  const communities = useSelector((state) => state.communities)

  const dispatch = useDispatch()

  const [comunidad, setComunidad] = useState()
  const [search, setSearch] = useState('none')
  const [page, setPage] = useState(1)

  const [firstRender, setFirstRender] = useState(true)

  const getAllComunities = () => dispatch(hospitalsActions.getAllCommunities())

  const getAllHospitalsByZoneCity = async () => {
    setLoading(true)
    try {
      await dispatch(
        hospitalsActions.getAllHospitalsByZoneCityPaged(comunidad, search, page),
      )
    } finally {
      setLoading(false)
    }
  }
  const clearHospitalsList = () =>
    dispatch(hospitalsActions.clearHospitalsList())
  const deleteHospital = (idHospital) =>
    dispatch(hospitalsActions.deleteHospital(idHospital))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      resetHospitalsList()
    }
    getAllComunities()
    window.addEventListener('scroll', _.throttle(onScroll, 500))
  }, [])

  useEffect(() => {
    setItems(hospitalsList)
  }, [hospitalsList])

  useEffect(() => {
    if (!firstRender) resetHospitalsList()
    else setFirstRender(!firstRender)
  }, [comunidad, search])

  useEffect(() => {
    if (!firstRender && page > 1) {
      getAllHospitalsByZoneCity()
    }
  }, [page])

  const resetHospitalsList = async () => {
    setPage(1)
    clearHospitalsList()
    setLoading(true)
    try {
      await dispatch(
        hospitalsActions.getAllHospitalsByZoneCityPaged(comunidad, search, 1),
      )
    } finally {
      setLoading(false)
    }
  }

  const onScroll = () => {
    const documentHeight = document.body.scrollHeight
    const currentScroll = window.scrollY + window.innerHeight
    const modifier = 50

    if (currentScroll + modifier > documentHeight) {
      setPage((p) => p + 1)
    }
  }

  const handleRemove = async (idHospital) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el hospital? Se eliminaran todos los contactos asociados a este hospital',
      )
      if (alert.isConfirmed) {
        const response = await deleteHospital(idHospital)
        if (response.type === hospitalsTypes.DELETE_HOSPITAL_SUCCESS) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
        }
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const toNewHospital = () => {
    history.push(routes.HOSPITAL_NEW)
  }

  const toEditHospitals = (id) => {
    history.push(routes.HOSPITAL_EDIT + id)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const handleChangeOption = (event) => {
    setComunidad(event.target.value);
  }

  const onChangeSearch = (value) => {
    if (value.trim() == '') setSearch('none')
    else setSearch(value.trim())
  }

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.HOSPITALS),
    )
    downloadCSV("Hospitales", response)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header text={'Hospitales / Centros'} route={toBackoffice} backBtn={true} />
          <div className='filter__wrap mb-80'>
            <div>
              
              {userProfile.roles.isHospitalesVerTodos ? (
                <div className='sort-role__wrap'>
                  <h4 className='filter__title'>Filtrar por</h4>
                  <select className='select-filter' onChange={handleChangeOption}>
                    <option value={0} className='options-field'>
                      Todas las comunidades
                    </option>
                    {communities.length > 0
                      ? communities.map((zona) => (
                          <option
                            key={zona}
                            value={zona}
                            className='options-field'
                          >
                            {String(zona)}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              ) : null}
              
            </div>
            <Search onChangeSearch={onChangeSearch} placeholder={'Buscar...'} />
            <div className='add__action__rigth__side'>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginLeft: '10px' }}
              >
                📊 Exportar CSV
              </button>
              <button className='action-button' onClick={toNewHospital}>
                <PlusBtn />
                <span>Añadir hospital</span>
              </button>
            </div>
          </div>
          <div className='responsive-info'>
            <p className='responsive-info__text'>
              💡 En pantallas pequeñas, desliza horizontalmente para ver todos
              los datos
            </p>
          </div>
          <HospitalsList
            filteredHospitales={items}
            handleRemove={handleRemove}
            toEditHospitals={toEditHospitals}
            userProfile={userProfile}
            loading={loading}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(HospitalsContainer)
